module.exports = __webpack_public_path__ + "static/media/resume2020.1d53da76.pdf";